// Les photos du site, par sujet. Générées sur Google Cloud (Nano Banana Pro, 1376 × 768 → webp) : demandes dans
// ../outils/images/demandes/. 13 photos générées le 28/10/2026 (1,74 $).
export const photos = {
  portCasablanca: '/assets/photos/port-casablanca.webp',
  tangerMed: '/assets/photos/tanger-med.webp',
  fretAerien: '/assets/photos/fret-aerien.webp',
  camionAutoroute: '/assets/photos/camion-autoroute.webp',
  documents: '/assets/photos/documents.webp',
  entrepot: '/assets/photos/entrepot.webp',
  agrumes: '/assets/photos/agrumes-export.webp',
  inspection: '/assets/photos/inspection-conteneur.webp',
  cuirFes: '/assets/photos/cuir-fes.webp',
  riadMarrakech: '/assets/photos/livraison-marrakech.webp',
  industrie: '/assets/photos/industrie.webp',
  equipement: '/assets/photos/equipement.webp',
  nador: '/assets/photos/port-nador.webp',
} as const

export type Photo = keyof typeof photos

// Photo de chaque page service et de chaque ville.
export const photoService: Record<string, Photo> = {
  'transit-dedouanement': 'inspection', import: 'entrepot', export: 'agrumes', 'fret-maritime': 'portCasablanca',
  'fret-aerien': 'fretAerien', 'transport-routier': 'camionAutoroute', 'conseil-accompagnement': 'documents',
}
export const photoVille: Record<string, Photo> = {
  'transitaire-casablanca': 'portCasablanca', 'transitaire-tanger': 'tangerMed', 'transitaire-agadir': 'agrumes',
  'transitaire-marrakech': 'riadMarrakech', 'transitaire-rabat': 'equipement', 'transitaire-fes': 'cuirFes',
  'transitaire-nador': 'nador', 'transitaire-kenitra': 'industrie',
}
